import { RouteCodes } from '@core/config/route-codes';
import { POSITION_ROUTES_TREE } from '@core/config/routes-tree';
import { StepCodes } from '@core/config/step-codes';
import { STEPS_CONFIG as CORE_STEPS_CONFIG } from '@core/config/steps-config';
import { StepConfigModel } from '@models/wizard/steps-config.model';

export const STEPS_CONFIG: {
  [stepCode: string]: StepConfigModel;
} = {
  ['SELF-PRIVACY']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['SELF-FINALITY']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['SELF-INCOME-DATA']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['SELF-ADEGUACY']: {
    path: POSITION_ROUTES_TREE[RouteCodes.surveyCollection].path
  },
  ['SELF-EMPLOYMENT']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['SELF-PROOF-OF-INCOME']: {
    path: POSITION_ROUTES_TREE[RouteCodes.financialData].path
  },
  ['SELF-POI-LITE']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['SELF-RESIDENCY']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['SELF-DOMICILE']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['SELF-ADDITIONAL-DATA']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['SELF-FOREIGNER']: {
    ...CORE_STEPS_CONFIG[StepCodes.foreigner]
  },
  ['SELF-IBAN']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['SELF-WAIT-SECCI']: {
    path: POSITION_ROUTES_TREE[RouteCodes.waiting].path,
    params: { waitingType: 'short' }
  },
  ['SELF-QUOTATION-CONFIRM']: { ...CORE_STEPS_CONFIG[StepCodes.quotation] },
  ['SELF-WAIT-CONTR']: {
    path: POSITION_ROUTES_TREE[RouteCodes.waiting].path,
    params: { waitingType: 'short' }
  },
  ['SELF-CONTRACT-SIGN']: {
    path: POSITION_ROUTES_TREE[RouteCodes.contractSigning].path,
    params: { skipStatusCheck: true, avoidExit: true }
  },
  ['SELF-HANDOVER-START']: {
    path: POSITION_ROUTES_TREE[RouteCodes.handoverStart].path
  },
  ['SELF-HANDOVER-UPLOAD']: {
    path: POSITION_ROUTES_TREE[RouteCodes.documentsRequest].path
  }
};
